const anchorMenus = document.querySelectorAll('.anchor-menu');
const anchorTargets = document.querySelectorAll('main section[id], main [data-course-content] h2[id]');

const setAnchorMenuHeight = () => {
	anchorMenus.forEach((menu) => {
		document.documentElement.style.setProperty('--anchor-menu-height', `${menu.offsetHeight}px`);
	});
};

setAnchorMenuHeight();
window.addEventListener('resize', setAnchorMenuHeight);

anchorMenus.forEach((menu) => {
	const scrollDiv = menu.querySelector('.overflow-parent');
	const overflowGradient = scrollDiv?.querySelector('[data-overflow-gradient]');
	const menuItems = menu.querySelectorAll('a');
	const mobileSelect = menu.querySelector('select');
	const currentHash = window.location.hash.split('#')[1];

	const updateOverflowGradient = () => {
		if (!scrollDiv || !overflowGradient) {
			return;
		}

		if (scrollDiv.scrollLeft > 0) {
			overflowGradient.classList.add('hidden');
		} else {
			overflowGradient.classList.remove('hidden');
		}
	};

	if (scrollDiv) {
		scrollDiv.addEventListener('scroll', () => {
			scrollDiv.classList.add('is-scrolled');
			updateOverflowGradient();
		});

		updateOverflowGradient();
	}

	document.addEventListener('scrollend', () => {
		let scrollTrigger = true;

		anchorTargets.forEach((section) => {
			const top = section.getBoundingClientRect().top + document.documentElement.scrollTop - menu.offsetHeight;
			const bottom = section.getBoundingClientRect().bottom + document.documentElement.scrollTop;
			const activeItem = menu.querySelector('a[href="#' + section.id + '"]');
			const marginTop = parseInt(getComputedStyle(section).marginTop, 10) || 0;
			const correctedTop = top - marginTop - menu.offsetHeight;

			if (window.scrollY < menu.getBoundingClientRect().top) {
				menuItems.forEach((item) => item.classList.remove('is-active'));
				if (menuItems[0]) {
					menuItems[0].classList.add('is-active');
				}
				if (mobileSelect && menuItems[0]) {
					mobileSelect.value = menuItems[0].href.split('#')[1];
				}
			} else if (correctedTop <= window.scrollY && window.scrollY <= bottom) {
				if (activeItem && activeItem.classList.contains('is-active')) {
					scrollTrigger = false;
				}

				menuItems.forEach((item) => item.classList.remove('is-active'));
				if (activeItem) {
					activeItem.classList.add('is-active');
				}
				if (mobileSelect && activeItem) {
					mobileSelect.value = activeItem.href.split('#')[1];
				}

				if (scrollTrigger && scrollDiv && activeItem) {
					scrollDiv.scrollTo({
						left: activeItem.offsetLeft,
						behavior: 'smooth',
					});
				}
			}
		});
	});

	menuItems.forEach((item) => {
		item.addEventListener('click', () => {
			const anchorID = item.href.split('#')[1];
			if (mobileSelect) {
				mobileSelect.value = anchorID;
			}
			menuItems.forEach((sibling) => sibling.classList.remove('is-active'));
			item.classList.add('is-active');
		});
	});

	if (mobileSelect) {
		mobileSelect.addEventListener('change', () => {
			window.location.hash = mobileSelect.value;
			document.getElementById(mobileSelect.value)?.focus();
		});
	}

	if (currentHash && mobileSelect) {
		mobileSelect.value = currentHash;
	}
});
